"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormSetValue = exports.useFormIsSubmitting = exports.useFormError = exports.useFormValue = exports.useFormContext = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var use_context_selector_1 = require("use-context-selector");
var FormContext = (0, use_context_selector_1.createContext)(null);
function useFormContext() {
    return (0, use_context_selector_1.useContextSelector)(FormContext, function (context) { return context; });
}
exports.useFormContext = useFormContext;
function useFormValue(name, propValue) {
    var formValue = (0, use_context_selector_1.useContextSelector)(FormContext, function (context) { return (name ? context === null || context === void 0 ? void 0 : context.getFieldValue(name) : null); });
    return propValue !== null && propValue !== void 0 ? propValue : formValue;
}
exports.useFormValue = useFormValue;
function useFormError(name, propError) {
    var _a;
    var formError = (0, use_context_selector_1.useContextSelector)(FormContext, function (context) { return (name ? context === null || context === void 0 ? void 0 : context.getFieldError(name) : null); });
    return (_a = propError !== null && propError !== void 0 ? propError : formError) !== null && _a !== void 0 ? _a : undefined;
}
exports.useFormError = useFormError;
function useFormIsSubmitting() {
    return (0, use_context_selector_1.useContextSelector)(FormContext, function (context) { return context === null || context === void 0 ? void 0 : context.isSubmitting; });
}
exports.useFormIsSubmitting = useFormIsSubmitting;
function useFormSetValue(name) {
    var contextSetFieldValue = (0, use_context_selector_1.useContextSelector)(FormContext, function (context) {
        if (!name)
            return null;
        return context === null || context === void 0 ? void 0 : context.setFieldValue;
    });
    return React.useCallback(function (value) { return contextSetFieldValue && contextSetFieldValue(name, value); }, [contextSetFieldValue, name]);
}
exports.useFormSetValue = useFormSetValue;
exports.default = FormContext;
